@use 'tokens.module' as t;

.header {
  @media screen and (min-width: 768px) {
    display: flex;
  }
}

.title-wrapper {
  flex: 1;
  margin-bottom: 1rem;

  @media screen and (min-width: t.$tablet) {
    margin: 0 0 0 30px;
  }
}

.course-title {
  line-height: 1.2;

  @media screen and (min-width: t.$tablet) {
    margin-bottom: 10px;
  }
}

.image-wrapper {
  margin-bottom: -120px;
  padding: 0 20px;
  width: 100%;

  @media screen and (min-width: 768px) {
    margin-right: 30px;
    padding: 0;
    width: 360px;
  }
}

.image {
  background-color: t.$white;
  background-image: url(../../../assets/fallback.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 56%;
  position: relative;
  z-index: 1;
  border-radius: 4px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);

  @media screen and (max-width: t.$tablet) {
    margin-top: 2rem;
  }
}

.logo-wrapper {
  background-color: t.$white;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  position: absolute;
  right: 40px;
  top: -42px;
  width: 80px;
}

.force-text-reflow {
  float: right;
  height: 110px;
  width: 380px;
}

.long-description {
  word-break: break-word;
  padding: 130px 0 10px;

  @media screen and (min-width: 768px) {
    min-height: 120px;
    padding: 0 392px 16px 0;
  }
}
